import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { AxiosError } from 'axios';
import { FC, ReactNode } from 'react';
import { toErrorResponse } from 'src/common/services/errors';
import { environment } from 'src/config/environment';
import * as Sentry from '@sentry/browser';

const shouldLogErrorToSentry = (error: unknown) => {
  if (
    error instanceof AxiosError &&
    error.response?.status &&
    [401, 403, 404].includes(error.response.status)
  ) {
    return false;
  }

  return true;
};

const handleSentryLog = (err: unknown) => {
  if (shouldLogErrorToSentry(err)) {
    Sentry.captureException(err);
  }
};

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnMount: false,
      refetchOnReconnect: false,
      refetchOnWindowFocus: false,
      retry: false,
      onError: (err) => {
        toErrorResponse(err);
        handleSentryLog(err);
      },
    },
    mutations: {
      onError: (err) => {
        toErrorResponse(err);
        handleSentryLog(err);
      },
    },
  },
});
interface ReactQueryClientProviderProps {
  children?: ReactNode;
}

export const ReactQueryClientProvider: FC<ReactQueryClientProviderProps> = ({
  children,
}) => {
  return (
    <QueryClientProvider client={queryClient}>
      {environment.isDevelopment && <ReactQueryDevtools />}
      {children}
    </QueryClientProvider>
  );
};
